const SWATCH_SELECTOR = ".c-card__colorball[data-variant-id]";
const CARD_SELECTOR = "[data-product-card]";

export default class CardProductVariantSwatch {
  constructor() {
    if (CardProductVariantSwatch.instance) {
      return CardProductVariantSwatch.instance;
    }

    CardProductVariantSwatch.instance = this;
    this.recentSwatch = null;

    this.handleSwatchPointerDown = this.handleSwatchPointerDown.bind(this);
    this.handleSwatchClick = this.handleSwatchClick.bind(this);
    this.handleSwatchKeydown = this.handleSwatchKeydown.bind(this);
    this.handleImageWrapperHover = this.handleImageWrapperHover.bind(this);

    this.init();
  }

  init() {
    document.addEventListener("pointerdown", this.handleSwatchPointerDown, true);
    document.addEventListener("click", this.handleSwatchClick, true);
    document.addEventListener("keydown", this.handleSwatchKeydown);
    document.addEventListener("mouseover", this.handleImageWrapperHover);
  }

  destroy() {
    document.removeEventListener("pointerdown", this.handleSwatchPointerDown, true);
    document.removeEventListener("click", this.handleSwatchClick, true);
    document.removeEventListener("keydown", this.handleSwatchKeydown);
    document.removeEventListener("mouseover", this.handleImageWrapperHover);

    CardProductVariantSwatch.instance = null;
  }

  updateCardFromSwatch(swatch, card) {
    const productLink = card.querySelector("[data-product-link]");

    if (productLink && swatch.dataset.variantUrl) {
      productLink.setAttribute("href", swatch.dataset.variantUrl);
    }

    const image = card.querySelector("img[data-main-image]");

    if (image) {
      if (swatch.dataset.variantImageSrc) image.setAttribute("src", swatch.dataset.variantImageSrc);
      if (swatch.dataset.variantImageSrcset) image.setAttribute("srcset", swatch.dataset.variantImageSrcset);
      if (swatch.dataset.variantImageWidth) image.setAttribute("width", swatch.dataset.variantImageWidth);
      if (swatch.dataset.variantImageHeight) image.setAttribute("height", swatch.dataset.variantImageHeight);
    }

    const imageWrapper = card.querySelector(".c-card__image");

    if (imageWrapper) {
      imageWrapper.classList.add("is-variant-selected");
    }

    card.querySelectorAll(SWATCH_SELECTOR).forEach((el) => {
      el.classList.remove("is-active");
      el.setAttribute("aria-pressed", "false");
    });

    swatch.classList.add("is-active");
    swatch.setAttribute("aria-pressed", "true");

    if (card.dataset.canUpdatePrice !== "true") return;

    const priceContainer = card.querySelector("[data-price-container]");

    if (!priceContainer || !swatch.dataset.variantPrice) return;

    const comparePrice = swatch.dataset.variantComparePrice;
    const compareMarkup = comparePrice
      ? '<s class="c-card__price__number" style="margin-left: 5px;">' + comparePrice + "</s>"
      : "";
    priceContainer.innerHTML =
      '<span class="c-card__price__number">' + swatch.dataset.variantPrice + "</span>" + compareMarkup;
  }

  handleSwatchPointerDown(event) {
    if (event.button !== undefined && event.button !== 0) return;

    const swatch = event.target.closest(SWATCH_SELECTOR);

    if (!swatch) return;

    event.preventDefault();

    const card = swatch.closest(CARD_SELECTOR);

    if (!card) return;

    this.recentSwatch = swatch;
    this.updateCardFromSwatch(swatch, card);
  }

  handleSwatchClick(event) {
    if (!this.recentSwatch) return;

    event.preventDefault();
    event.stopPropagation();
    this.recentSwatch = null;
  }

  handleSwatchKeydown(event) {
    if (event.key !== "Enter" && event.key !== " ") return;

    const swatch = event.target.closest(SWATCH_SELECTOR);

    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();

    const card = swatch.closest(CARD_SELECTOR);

    if (!card) return;

    this.updateCardFromSwatch(swatch, card);
  }

  handleImageWrapperHover(event) {
    const imageWrapper = event.target.closest(".c-card__image");

    if (!imageWrapper) return;

    imageWrapper.classList.remove("is-variant-selected");
  }
}
